import { useRef as n, useEffect as s } from "react";
import { linkifyPlainText as i } from "./utils/linkify-text.mjs";
const u = ({ editor: t, content: e, shouldInitialize: r }) => {
  const f = n(!1);
  s(() => {
    !t || !e || f.current || !r || typeof e != "string" || (t.commands.setContent(i(e)), f.current = !0);
  }, [t, e, r]);
};
export {
  u as useInitContentWithLinkifiedText
};
